export function combineDateTimeToISO(dateStr, timeStr) {
  if (!dateStr || !timeStr) return "";

  const date = new Date(`${dateStr}T${timeStr}`);

  if (Number.isNaN(date.getTime())) return "";

  return date.toISOString();
}

export function generateCycleDates({
  startDateLocal,
  startTimeLocal,
  frequencyType,
  everyNDays,
  everyNHours,
  weeklyDay,
  durationDays,
}) {
  const startISO = combineDateTimeToISO(startDateLocal, startTimeLocal);
  const start = startISO ? new Date(startISO) : null;

  if (!start || Number.isNaN(start.getTime())) return [];

  const safeDurationDays = Math.max(1, Number(durationDays) || 1);
  const dates = [];

  if (frequencyType === "DAILY") {
    for (let index = 0; index < safeDurationDays; index += 1) {
      const currentDate = new Date(start);
      currentDate.setDate(currentDate.getDate() + index);
      dates.push(currentDate.toISOString());
    }

    return dates;
  }

  if (frequencyType === "EVERY_N_HOURS") {
    const safeHours = Math.max(1, Number(everyNHours) || 8);
    const endMs = start.getTime() + safeDurationDays * 24 * 60 * 60 * 1000;
    const stepMs = safeHours * 60 * 60 * 1000;

    let cursorMs = start.getTime();
    while (cursorMs < endMs) {
      dates.push(new Date(cursorMs).toISOString());
      cursorMs += stepMs;
    }

    return dates;
  }

  if (frequencyType === "EVERY_N_DAYS") {
    const safeEveryNDays = Math.max(1, Number(everyNDays) || 1);

    for (let offset = 0; offset < safeDurationDays; offset += safeEveryNDays) {
      const currentDate = new Date(start);
      currentDate.setDate(currentDate.getDate() + offset);
      dates.push(currentDate.toISOString());
    }

    return dates;
  }

  if (frequencyType === "WEEKLY") {
    const targetWeekDay = Number(weeklyDay);
    const endDate = new Date(start);
    endDate.setDate(endDate.getDate() + (safeDurationDays - 1));

    const cursor = new Date(start);

    while (cursor <= endDate) {
      if (cursor.getDay() === targetWeekDay) {
        dates.push(new Date(cursor).toISOString());
      }

      cursor.setDate(cursor.getDate() + 1);
    }

    return dates;
  }

  return [];
}